// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__S1cxi","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__38OiI"};